module.exports = __webpack_public_path__ + "static/media/support-from-the-boss.af7e83e0.png";